export enum TechSheetFieldType {
  TEXT = "text",
  SINGLE_SELECT = "single_select",
  MULTI_SELECT = "multi_select",
}
